import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Phone, Mail, MapPin } from "lucide-react";
import { SocialLinks } from "./SocialLinks";

export function Footer() {
  return (
    <footer className="bg-brand text-brand-bg mt-24">
      <div className="mx-auto max-w-7xl px-6 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo variant="wordmark" light height={52} />
          <p className="mt-5 text-sm text-brand-bg/70 max-w-sm leading-relaxed">
            Premium certified-organic farming solutions for Ghana. Eco-friendly, non-toxic inputs
            that protect your crops and the environment — delivered to your door, pay on delivery.
          </p>
          <div className="mt-6"><SocialLinks variant="footer" /></div>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-ochre font-semibold mb-4">Explore</h4>
          <ul className="space-y-3 text-sm text-brand-bg/80">
            <li><Link to="/shop" className="hover:text-brand-ochre transition-colors">Shop</Link></li>
            <li><Link to="/about" className="hover:text-brand-ochre transition-colors">About Us</Link></li>
            <li><Link to="/team" className="hover:text-brand-ochre transition-colors">Our Team</Link></li>
            <li><Link to="/blog" className="hover:text-brand-ochre transition-colors">Blog</Link></li>
            <li><Link to="/news" className="hover:text-brand-ochre transition-colors">News</Link></li>
            <li><Link to="/jobs" className="hover:text-brand-ochre transition-colors">Careers</Link></li>
            <li><Link to="/faq" className="hover:text-brand-ochre transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-brand-ochre transition-colors">Contact</Link></li>
            <li><Link to="/dashboard" className="hover:text-brand-ochre transition-colors">Track Order</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-brand-ochre font-semibold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-brand-bg/80">
            <li className="flex gap-2.5"><MapPin className="w-4 h-4 mt-0.5 shrink-0" />Organic Hill, Suhum, Eastern Region — Ghana</li>
            <li className="flex gap-2.5"><Phone className="w-4 h-4 mt-0.5 shrink-0" /><a href="tel:+233530485235" className="hover:text-brand-ochre">(+233) 053 048 5235</a></li>
            <li className="flex gap-2.5"><Mail className="w-4 h-4 mt-0.5 shrink-0" /><a href="mailto:info@yayraglover.com" className="hover:text-brand-ochre">info@yayraglover.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-bg/10 py-6 text-center text-xs text-brand-bg/50">
        © {new Date().getFullYear()} Yayra Glover Organic Inputs. Certified Organic · Eco Friendly · Non Toxic.
      </div>
    </footer>
  );
}
